import React, { useEffect } from 'react';
import System from "../../helper/system";

let c = System.getParams();
const { storageName: { UNIVERSAL_SEARCH_PARAM } } = System

const NoDataFound = () => {
    useEffect(() => {
        const fetchHere = async () => {
            c.search = c.search || localStorage.getItem(UNIVERSAL_SEARCH_PARAM);
            history.pushState(null, null, '?' + $.param(c));
            localStorage.setItem(UNIVERSAL_SEARCH_PARAM, '')
        }

        fetchHere()
    }, [])

    const searchParam = c.search || localStorage.getItem(UNIVERSAL_SEARCH_PARAM);
    const { translation:t } = System;

    return (
        <div className="note container">
            <div className='text-start nosearchfound mb-4'>
                <b>
                    <i className="fa fa-info-circle text-black me-1" aria-hidden="true" />
                    {t('zeroSearchResultsFoundFor')} "{searchParam}".
                </b> &nbsp; {t('lookBelowForMoreHelp')} &nbsp;
                <a href={System.redirectToNewark(searchParam).link} className='text-blue-dark'>
                    <u>{System.redirectToNewark(searchParam).name}</u>
                </a>.
            </div>
        </div>
    );
}

export default NoDataFound;